export enum FUEL_TYPE_CREATION_OPTION {
  UPDATE_FUEL_TYPE_INFORMATION = 'updateFuelTypeInformation',
}
